module.exports = __webpack_public_path__ + "img/vito.ff26721f.jpg";